<template>
  <div class="skill-picker-popover" :class="{ open: skillPickerOpen }" v-show="skillPickerOpen">
    <div class="skill-picker-head">
      <div class="skill-picker-title">选择技能</div>
      <div style="display:flex;align-items:center;gap:8px;">
        <button v-if="selectedSkillIds.length > 0" class="skill-picker-clear" type="button" @click.stop="clearAll">清空</button>
        <button class="skill-picker-close-btn" type="button" @click="SET_SKILL_PICKER_OPEN(false)">✕</button>
      </div>
    </div>
    <input
      v-model="query"
      class="skill-picker-search-input"
      type="text"
      placeholder="搜索技能名称..."
      @click.stop
    />
    <div class="skill-picker-list">
      <div v-if="agentSkillLoading" class="skill-picker-loading">
        <svg class="skill-picker-spinner" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="#d1d5db" stroke-width="3"/>
          <path d="M12 2a10 10 0 019.8 8" stroke="#5B8DEF" stroke-width="3" stroke-linecap="round">
            <animateTransform attributeName="transform" type="rotate" dur=".7s" from="0 12 12" to="360 12 12" repeatCount="indefinite"/>
          </path>
        </svg>
        <span>加载技能中...</span>
      </div>
      <template v-else>
        <button
          v-for="skill in filteredSkills"
          :key="skill.id"
          class="skill-picker-item"
          :class="{ active: isSelected(skill.id) }"
          type="button"
          @click.stop="toggle(skill.id)"
        >
          <div class="skill-picker-item-main">
            <div class="skill-picker-item-icon">
              <img v-if="isUrlIcon(skill.icon)" :src="skill.icon" alt="" class="skill-picker-item-icon-img" @error="onIconError" />
              <span v-else>{{ skill.icon }}</span>
            </div>
            <div class="skill-picker-item-title">{{ skill.name || skill.title }}</div>
            <span v-if="isSelected(skill.id)" class="skill-picker-item-check">✓</span>
          </div>
          <div class="skill-picker-item-desc">{{ skill.skillDescription || skill.desc }}</div>
        </button>
        <div v-if="filteredSkills.length === 0" style="padding:16px;text-align:center;color:#94a3b8;font-size:13px;">
          暂无匹配技能
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'SkillPickerPopover',
  data() { return { query: '' } },
  computed: {
    ...mapState(['skillPickerOpen', 'skillPickerTriggerRect', 'agentSkillLoading']),
    ...mapGetters(['composerSkillPresets', 'selectedSkillIds']),
    skills() { return this.composerSkillPresets },
    filteredSkills() {
      const q = (this.query || '').trim().toLowerCase()
      if (!q) return this.skills
      return this.skills.filter(s =>
        (s.name || s.title || '').toLowerCase().includes(q) || (s.skillDescription || s.desc || '').toLowerCase().includes(q)
      )
    }
  },
  watch: {
    skillPickerOpen(val) {
      if (val) {
        this.query = ''
        this.$nextTick(() => this.applyPosition())
      }
    },
    agentSkillLoading(val) {
      if (!val && this.skillPickerOpen) {
        this.$nextTick(() => this.applyPosition())
      }
    }
  },
  methods: {
    ...mapMutations(['TOGGLE_SKILL', 'CLEAR_SKILLS', 'SET_SKILL_PICKER_OPEN']),
    isSelected(id) { return this.selectedSkillIds.includes(id) },
    // skill.icon 后端要么是 URL（http/https/data/blob/相对路径 /）要么是 emoji/单字，按前缀判
    isUrlIcon(s) { return typeof s === 'string' && /^(https?:|data:|blob:|\/)/.test(s) },
    onIconError(e) { try { e.target.style.display = 'none' } catch (_) {} },
    toggle(id) { this.TOGGLE_SKILL(id) },
    clearAll() { this.CLEAR_SKILLS() },
    applyPosition() {
      const self = this
      requestAnimationFrame(function () {
        const rect = self.skillPickerTriggerRect
        if (!rect || !self.$el) return
        const width = 320
        const fixedHeight = 360
        const margin = 12
        const gap = 10
        const left = Math.min(window.innerWidth - width - margin, Math.max(margin, rect.left))
        // 固定向上弹出
        const top = rect.top - gap - fixedHeight
        self.$el.style.left = left + 'px'
        self.$el.style.top = Math.max(margin, top) + 'px'
        self.$el.style.height = fixedHeight + 'px'
        self.$el.classList.add('is-upward')
        self.$el.classList.remove('is-downward')
      })
    },
    handleGlobalClick(e) {
      if (this.skillPickerOpen && !this.$el.contains(e.target)) {
        this.SET_SKILL_PICKER_OPEN(false)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener('click', this.handleGlobalClick)
    })
    this.$nextTick(() => this.applyPosition())
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick)
  }
}
</script>

<style scoped>
.skill-picker-loading {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 10px; padding: 32px 16px; color: #94a3b8; font-size: 13px; font-weight: 500;
}
</style>
